import React from "react";
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import SearchIcon from '@mui/icons-material/Search';
import LocationPinIcon from '@mui/icons-material/LocationPin';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import FavoriteIcon from '@mui/icons-material/Favorite';
import YouTubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from '@mui/icons-material/Instagram';
import Twitter from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import './Footer.css';
import DevelopersInfo from "./DevelopersInfo";

const Footer = () => {
    return (
        <>
            <footer class="footer">
                <div class="footer-top">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-3 pe-5">
                                <h5 class="footer-head">Monday to Saturday – 9 to 7 pm, Sunday closed</h5>
                                <a href="#" class="footer-logo">
                                    <img src="images/logo-white.png" alt="Footer Logo" class="img-fluid footer-logo-img" />
                                </a>
                                <p className="footer-text">Credere Finance aims to support your dream of attaining a high-quality education and provide students with easy access to personalized educational finance alternatives.</p>
                                
                                <DevelopersInfo />
                                {/* <form>
                                    <div className="footer-subscribe">
                                        <input type="email" className="form-control" placeholder="Enter your email" />
                                        <button type="submit" className="submit-btn"><SearchIcon /></button>
                                    </div>
                                </form> */}
                            </div>
                            <div class="col-md-3 border-left ps-5">
                                <h5 class="footer-head">Loan Partners</h5>
                                <ul class="common-li-footer" style={{ marginTop: '60px' }}>
                                    
                                    <li style={{ marginTop: '5px' }}><a href="/sbi-lending-partner"><KeyboardDoubleArrowRightIcon />&nbsp; SBI Education Loan</a></li>
                                    <li style={{ marginTop: '5px' }}><a href="/bob-lending-partner"><KeyboardDoubleArrowRightIcon />&nbsp; BoB Education Loan</a></li>
                                    <li style={{ marginTop: '5px' }}><a href="/ubi-education-lending-partner"><KeyboardDoubleArrowRightIcon />&nbsp; UBI Education Loan</a></li>
                                    <li style={{ marginTop: '5px' }}><a href="/icici-bank-lending-partner"><KeyboardDoubleArrowRightIcon />&nbsp; ICICI Education Loan</a></li>
                                    <li style={{ marginTop: '5px' }}><a href="/axis-bank-lending-partner"><KeyboardDoubleArrowRightIcon />&nbsp; Axis Education Loan</a></li>
                                    <li style={{ marginTop: '5px' }}><a href="/idfc-first-lending-partner"><KeyboardDoubleArrowRightIcon />&nbsp; IDFC First Education Loan</a></li>
                                    <li style={{ marginTop: '5px' }}><a href="/prodigy-finance-lending-partner"><KeyboardDoubleArrowRightIcon />&nbsp; Prodigy Education Loan</a></li>
                                    <li style={{ marginTop: '5px' }}><a href="/mpower-financing-lending-partner"><KeyboardDoubleArrowRightIcon />&nbsp; Mpower Education Loan</a></li>
                                    <li style={{ marginTop: '5px' }}><a href="/hdfc-credila-lending-partner"><KeyboardDoubleArrowRightIcon />&nbsp; Credila Education Loan</a></li>
                                    <li style={{ marginTop: '5px' }}><a href="/avanse-lending-partner"><KeyboardDoubleArrowRightIcon />&nbsp; Avanse Education Loan</a></li>
                                    <li style={{ marginTop: '5px' }}><a href="/incred-lending-partner"><KeyboardDoubleArrowRightIcon />&nbsp; Incred Education Loan</a></li>
                                    <li style={{ marginTop: '5px' }}><a href="/auxilo-lending-partner"><KeyboardDoubleArrowRightIcon />&nbsp; Auxilo Education Loan</a></li>
                                </ul>
                            </div>
                            <div class="col-md-2 border-right">
                                <h5 class="footer-head">Main Menu</h5>
                                <ul class="common-li-footer" style={{ marginTop: '60px' }}>
                                    <li style={{ marginTop: '5px' }}><a href="/abroad-education-loan-overview"><KeyboardDoubleArrowRightIcon />&nbsp; Loans</a></li>
                                    <li style={{ marginTop: '5px' }}><a href="/abroad-scholarships"><KeyboardDoubleArrowRightIcon />&nbsp; Scholarships</a></li>
                                    <li style={{ marginTop: '5px' }}><a href="/faq"><KeyboardDoubleArrowRightIcon />&nbsp; FAQs</a></li>
                                    <li style={{ marginTop: '5px' }}><a href="/blog"><KeyboardDoubleArrowRightIcon />&nbsp; Blogs</a></li>
                                    <li style={{ marginTop: '5px' }}><a href="/about-us"><KeyboardDoubleArrowRightIcon />&nbsp; About Us</a></li>
                                    <li style={{ marginTop: '5px' }}><a href="/check-loan-eligibility"><KeyboardDoubleArrowRightIcon />&nbsp; Check Loan Eligibilty</a></li>
                                    {/* <li style={{ marginTop: '5px' }}><a href="/education-loan-emi-calculator"><KeyboardDoubleArrowRightIcon />&nbsp; Loan EMI Calculator</a></li> */}
                                    <li style={{ marginTop: '5px' }}><a href="/terms-conditions"><KeyboardDoubleArrowRightIcon />&nbsp; Terms & Conditions</a></li>
                                    <li style={{ marginTop: '5px' }}><a href="/privacy-policy"><KeyboardDoubleArrowRightIcon />&nbsp; Privacy Policy</a></li>
                                    <li style={{ marginTop: '5px' }}><a href="/become-a-partner"><KeyboardDoubleArrowRightIcon />&nbsp; Become a Partner</a></li>
                                    <li style={{ marginTop: '5px' }}><a href="/student-testimonials"><KeyboardDoubleArrowRightIcon />&nbsp; Student Testimonials</a></li>
                                </ul>
                            </div>
                            <div class="col-md-4 ps-5">
                                <h5 class="footer-head">Contact Us</h5>
                                <ul class="contact-footer" style={{ marginTop: '60px' }}>
                                    <li class="address"><a href="#"><LocationPinIcon className="footer-icon" />Credere Finance Plot number 3, Niti Khand - 2, Indirapuram, UP - 201014</a></li>
                                    <li class="call"><PhoneIcon className="footer-icon" /><br /><a href="tel:+91 98107 75641">+91- 83685 39434</a></li>
                                    <li class="mail"><a href="mailto:Info@crederefinance.com"><EmailIcon className="footer-icon" /><br />Info@crederefinance.com</a><br /><br /></li>
                                </ul>
                                <ul className="social-icons-head">
                                    <li>
                                        <a href="#" target="_blank">
                                            <Twitter className="social-icon" />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" target="_blank">
                                            <YouTubeIcon className="social-icon" />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" target="_blank">
                                            <InstagramIcon className="social-icon" />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" target="_blank">
                                            <LinkedInIcon className="social-icon" />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container copyright">
                    <p className="">© Credere 2025 All rights reserved</p>
                </div>
            </footer>
        </>
    );
}

export default Footer;